import { Component } from '@angular/core'
import { environment } from '../../../environments/environment'
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: true,
    imports: [CommonModule]
})
export class FooterComponent {

    protected readonly environment = environment

    isLoginErrorRoute: boolean = false;

    constructor(private router: Router) {}

    ngOnInit(): void {
        this.isLoginErrorRoute = this.router.url === '/login-error';

        this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
            this.isLoginErrorRoute = this.router.url === '/login-error';
        }
        });
    }
}
